export const fileDownload = (data: Blob | MediaSource, fileName?: string) => {
    const url = URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName ? fileName : Date.now().toLocaleString()}`;
    a.click();
    URL.revokeObjectURL(url);
};
